import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import downloadFile from '~/utils/downloadFile';
import { useSelector } from 'react-redux';
import * as S from '../styles';
import { parseData, columns } from '../utils';
import { propTypes, defaultProps } from './propsValidation';

export default function ProtocolCommercialActs({ acts, publicFiles }) {
  const { t } = useTranslation();
  const { data: match } = useSelector(state => state.matches.selectedMatch);
  const [pdfLoading, setPdfLoading] = useState(false);

  return (
    <S.Container>
      <S.TableHeader competition={match?.competitionId}>
        <S.Th>{t('period')}</S.Th>
        <S.Th>{t('actType')}</S.Th>
        <S.Th>{t('description')}</S.Th>
      </S.TableHeader>
      <S.TableCountdown
        columns={columns()}
        data={
          acts.previousActs
            ? parseData(acts.previousActs, 'priorToBeginning')
            : []
        }
      />
      {acts.previousActs && <S.TableSeparator />}
      <S.TableCountdown
        columns={columns()}
        data={acts.breakActs ? parseData(acts.breakActs, 'duringBreak') : []}
      />
      {acts.breakActs && <S.TableSeparator />}
      <S.TableCountdown
        columns={columns()}
        data={acts.endActs ? parseData(acts.endActs, 'afterTheMatch') : []}
      />
      <S.DownloadButton
        onClick={() => {
          if (publicFiles.data.actos)
            downloadFile(publicFiles.data.actos.id, setPdfLoading);
        }}
        text={t('downloadActsDesignation')}
        disabled={
          Object.keys(publicFiles.data).length === 0 || !publicFiles.data.actos
        }
        loading={pdfLoading}
        competition={match?.competitionId}
      />
    </S.Container>
  );
}

ProtocolCommercialActs.propTypes = propTypes;

ProtocolCommercialActs.defaultProps = defaultProps;
